<template>
  <div class="test-page">
    <div class="test-controls">
      <h1>Globe Isolation Test</h1>
      <p>This page renders ONLY the particle globe composable.</p>
      <button @click="goBack">Back to Main Site</button>
    </div>
    <div class="canvas-container">
      <canvas ref="canvasRef" id="test-globe-canvas"></canvas>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import { useParticleGlobe } from '@/composables/useParticleGlobe';

const canvasRef = ref(null);
let globe = null;

const config = {
  isLowEnd: false,
  animationQuality: 'high'
};

onMounted(() => {
  if (canvasRef.value) {
    globe = useParticleGlobe(canvasRef, config);
    globe.init();
  }
});

onUnmounted(() => {
  if (globe) {
    globe.cleanup();
  }
});

function goBack() {
  window.location.href = '/';
}
</script>

<style scoped>
.test-page {
  position: fixed;
  inset: 0;
  background: #0b0b0b;
  z-index: 9999;
  display: flex;
  flex-direction: column;
}

.test-controls {
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 10;
  color: white;
  background: rgba(0,0,0,0.8);
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #333;
}

.canvas-container {
  flex: 1;
  position: relative;
}

canvas {
  width: 100%;
  height: 100%;
  display: block;
}

button {
  margin-top: 10px;
  padding: 8px 16px;
  background: #F77E2D;
  border: none;
  color: white;
  border-radius: 4px;
  cursor: pointer;
}
</style>
